export default {
  name: 'ConfiraTodos'
}
